import { liveTickerTemporary } from './article/live-ticker-temporary-rugby-deutschland-2025.js';
import { rbaGoesOnline } from './article/rba-goes-online-2025.js';
import { rugbyBundesligaReform2025 } from './article/rugby-bundesliga-reform-2025-26.js';
import { rugbyBundesligaSaisonstart2025 } from './article/rugby-bundesliga-saisonstart-2025-26.js';
import { u20BundesligaStart2025 } from './article/u20-bundesliga-start-2025-26.js';
import { macronBallpartner } from './article/macron-ballpartner-2025.js';
import { veoKooperation } from './article/veo-kooperation-2025.js';
import { dmFinaleAusschreibung2026 } from './article/dm-finale-ausschreibung-2026.js';
import { neuePerspektiveRugbyBundesliga } from './article/neue-perspektive-rugby-bundesliga.js';
import { rugbyBundesligaNeuesJahr } from './article/rugby-bundesliga-neues-jahr.js';
import { deutscheRugbyMeisterschaft2026 } from './article/deutscheRugbyMesterschaft2026.js';
import { rugbyBundesligaRbaSitzungJanuar2026 } from './article/rba-sitzung-januar-2026.js';
import { onlineRugbyBundesligaTrainerinnenSymposium2026 } from './article/online-bundesligatrainerinnen-symposium-2026.js';
import { rugbyBundesligaTrainerSymposium2026Referenten } from './article/rugby-bundesliga-trainersymposium-2026-referenten.js';
import { deutscheMeisterschaftSiebenerRugbyFinalturnier2026 } from './article/deutsche-meisterschaft-siebener-rugby-finalturnier-2026.js';
import { roadToDieFinalsRugby7sQualifikation2026 } from './article/road-to-die-finals-rugby-7s-qualifikation-2026.js';
import { lizenzAntraegeRugbyBundesliga2026 } from './article/lizenz-antraege-rugby-bundesliga-2026.js';
import { rugbyBundesligaRbaSitzungJuni2026 } from './article/rba-sitzung-juni-2026-hannover.js';
import { bundesligaFinale2026Hannover } from './article/bundesliga-finale-2026-hannover.js';
import { bundesligaFinale2026Meister } from './article/bundesliga-finale-2026-sc-frankfurt-1880-meister.js';
import { rbaSitzung13Juni2026Bericht } from './article/rba-sitzung-13-juni-2026-bericht.js';
import { bundesligatrainerinnenSymposiumJuli2026 } from './article/bundesligatrainerinnen-symposium-juli-2026.js';
import { rugby7sQualifikation2026MuenchenBerlin } from './article/rugby-7s-qualifikation-2026-muenchen-berlin.js';
import { wildcard2BundesligaHerren2026 } from './article/wildcard-2-bundesliga-herren-2026-27.js';
import { deutscheMeisterschaft7erRugbyMaenner2026Hannover } from './article/deutsche-meisterschaft-7er-rugby-maenner-2026-hannover.js';
import { spielerpaesseBeantragenPassstelle2026 } from './article/spielerpaesse-beantragen-passstelle-2026.js';
import { scGermaniaListDoppelmeisterschaftFinals2026 } from './article/sc-germania-list-doppelmeisterschaft-finals-2026.js';
import { lizenzvergabeWildcardsBundesliga202627 } from './article/lizenzvergabe-wildcards-bundesliga-2026-27.js';
import { ausschreibungU20RugbyBundesliga202627 } from './article/ausschreibung-u20-rugby-bundesliga-2026-27.js';
import { bundesligasaison202627Startet } from './article/bundesligasaison-2026-27-startet.js';
import { ausschreibungBundesligafinale2027 } from './article/ausschreibung-bundesligafinale-2027.js';


export const newsArticles = [
  ausschreibungBundesligafinale2027,
  bundesligasaison202627Startet,
  ausschreibungU20RugbyBundesliga202627,
  lizenzvergabeWildcardsBundesliga202627,
  scGermaniaListDoppelmeisterschaftFinals2026,
  spielerpaesseBeantragenPassstelle2026,
  deutscheMeisterschaft7erRugbyMaenner2026Hannover,
  wildcard2BundesligaHerren2026,
  rugby7sQualifikation2026MuenchenBerlin,
  bundesligatrainerinnenSymposiumJuli2026,
  rbaSitzung13Juni2026Bericht,
  bundesligaFinale2026Meister,
  bundesligaFinale2026Hannover,
  rugbyBundesligaRbaSitzungJuni2026,
  lizenzAntraegeRugbyBundesliga2026,
  roadToDieFinalsRugby7sQualifikation2026,
  deutscheMeisterschaftSiebenerRugbyFinalturnier2026,
  rugbyBundesligaTrainerSymposium2026Referenten,
  onlineRugbyBundesligaTrainerinnenSymposium2026,
  rugbyBundesligaRbaSitzungJanuar2026,
  deutscheRugbyMeisterschaft2026,
  rugbyBundesligaNeuesJahr,
  neuePerspektiveRugbyBundesliga,
  dmFinaleAusschreibung2026,
  veoKooperation,
  macronBallpartner,
  u20BundesligaStart2025,
  rugbyBundesligaSaisonstart2025,
  liveTickerTemporary,
  rugbyBundesligaReform2025,
  rbaGoesOnline,
];
